import React from 'react';
import Logo from "../Components/Logo";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function Splash(props) {
    const navigate = useNavigate();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
            const token = match ? match[2] : null;
            if(!token) {
                window.location.replace('/login')
            }
            else {
                navigate('/requests');
            }

        }, 2000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (
        <React.Fragment>
            <section className="container-fluid splash  pt-5 ">
                <div className="row">
                    <div className="col-12 mt-5">
                        <Logo size={200} />
                    </div>
                    <h2 className="col-12 text-center mt-4 title text-secondary fw-bold">
                        اپلیکیشن ویژه خدمترسان
                    </h2>
                    <h6 className="col-12 text-center mt-4 text-muted text-small-1">
                        سامانه هوشمند خدماتی
                    </h6>
                    <div className="col-12 text-center fixed-bottom mb-3">
                        <div className="spinner-grow text-muted" role="status">

                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
